<ion-card class="md-settings">
  <form class="md-auth-form">
    <ion-grid>
      <ion-row class="ion-align-items-center">
        <ion-col>
          <div class="ion-padding">
            <div class="ion-margin-bottom">
              <ion-label>
                {{'workspace.settings.changePassword.labels.password' | translate}}
              </ion-label>
              <ion-item class="ion-margin-top">
                <ion-input required="true" type="password" [(ngModel)]="password" name="password">
                </ion-input>
              </ion-item>
              <password-strength-meter
                (strengthChange)="passwordStrengthChange($event)"
                [password]="password"
                [enableFeedback]="true"
              >
              </password-strength-meter>
            </div>
            <ion-label>
              {{'workspace.settings.changePassword.labels.verifyPassword' | translate}}
            </ion-label>
            <ion-item class="ion-margin-top">
              <ion-input
                [(ngModel)]="verifyPassword"
                required="true"
                type="password"
                name="verifyPassword"
              >
              </ion-input>
            </ion-item>
            <p
              *ngIf="_form.controls.verifiedPassword.touched && _form.controls.verifiedPassword.invalid"
              class="md-input-error"
              [innerHTML]="'errors.inputRequired' | translate: { value: ('auth.agencyCreate.account.inputNames.verifyPassword' | translate)}"
            ></p>
            <p
              *ngIf="verifyPassword && password !== verifyPassword"
              class="md-input-error"
              [innerHTML]="'errors.passwordMatch' | translate"
            ></p>
          </div>

          <ion-button
            class="page-option"
            fill="solid"
            color="primary"
            (click)="savePassword()"
            [disabled]="passwordStrength && passwordStrength < 1 || (verifyPassword && password !== verifyPassword)"
          >
            {{'workspace.settings.changePassword.saveButton' | translate}}
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </form>
</ion-card>
